export const menuList = {
  home: { label: "home", icon: "home", path: "home" },
  fields: { label: "fields", icon: "format_list_bulleted", path: "fields" },
  realtime: { label: "realtime", icon: "show_chart", path: "realtime" },
  wiki: { label: "wiki", icon: "menu_book", path: "wiki" },
};
